let main = document.querySelector('section.main') ?? document.body

for (let heroSection of document.querySelectorAll('.hero-section')) {
  let mediaElement = heroSection.querySelector('.hero-media')

  // Scroll to next element if clicking the indicator
  let scrollIndicatorButton = mediaElement.querySelector('.hero-scroll-indicator')
  scrollIndicatorButton?.addEventListener('click', () => {
    let current = heroSection
    if (main.contains(current) && current.parentNode !== main) {
      while (current.parentNode !== main) {
        current = current.parentNode
      }
    }

    let nextElement = current.nextElementSibling
    while (nextElement) {
      if (nextElement.offsetHeight > 0) break
      nextElement = nextElement.nextElementSibling
    }

    nextElement?.scrollIntoView({
      // behavior: 'smooth',
      behavior: 'auto',
      block: 'start',
    })
  })
}
